<template>
    <div>
    <div class="modal" :class="showMe ? 'show' : ''" :style="showMe ? 'display: block;' : ''">
        <div class="modal-lg modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <section class="title" style="border-top-right-radius: 5px;border-top-left-radius: 5px;">
                <div class="container-fluid">
                    <div class="row">
                    <div class="col-lg-12 padding-none text-center">
                        <div class="nav-cleaning">
                        <div class="title">
                            <label class="text-white">{{title}}</label>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="modal-body p-2 text-center" >
                <p>By clicking "Yes" you acknowledged that you have enabled notifications for Ovvy. This ensures that you stay updated on important alerts and messages from the platform.</p>
                <button @click="verify()" class="btn btn-red-white">Yes</button>
            </div>
          </div>
        </div>
    </div>
    </div>
    </template>
      
<script>
      import { updateNotificationOn } from "@/api" 
      import { lsWatcher as ls } from "../main";

      export default {
        name: 'NotificationVerifier',
        components: {
        },
        props: {
        },
        data() {
          return {
            showMe: false,
            loaded: false,
            items: [],
            job: {},
            title: 'Notifications',
          }
        },
        watch: {
            showMe: function(newVal) {
                if(newVal) this.$root.modalShow()
                else this.$root.modalClose();
            }
        },
        methods: {
            async verify() {
                const $this = this
                this.$root.isLoading = true
                
                await updateNotificationOn().then(response => {
                    $this.$root.isLoading = false
                    let data = response.data;
                    // console.log(data)
                    if(data.verified) {
                        ls.setItem("user_notification_verified", true);
                        $this.showMe = false
                    }
                }).catch(error => {
                    console.log(error)
                })
            }
        },
        created() {
            const $this = this;
            setTimeout(function() {
                $this.showMe = true
            }, 2000)
        }
      }
</script>

<style scoped>
    .btn-red-white {
        background-color: #F44336;
        width: 40%;
        color: #fff;
    }
</style>